/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AddQuoteFromPORequestDto {
  currency?: string | null;
  noteToSupplier?: string | null;
  poRequestIds?: number[] | null;
  sendMailAutomaticaly?: boolean;
  supplierEmail?: string | null;
  /** @format int32 */
  supplierId?: number;
  /** @format int32 */
  timeoutDays?: number;
}

export interface AddQuoteFromQuoteRequestDto {
  noteToSupplier?: string | null;
  quoteItemIds?: number[] | null;
  sendMailAutomaticaly?: boolean;
  /** @format int32 */
  supplierId?: number;
  /** @format int32 */
  timeoutDays?: number;
}

export interface ApprovePORequestDto {
  /** @format double */
  approvedQuantity?: number;
  /** @format int32 */
  id?: number;
}

export type AuthEnvironmentListData = ObjectApiResponseDto;

export type AuthRequestOtpCreateData = ObjectApiResponseDto;

export interface AuthResponseDto {
  /** @format date-time */
  expiresAt?: Date;
  token?: string | null;
  user?: UserInfoDto;
}

export interface AuthResponseDtoApiResponseDto {
  data?: AuthResponseDto;
  errors?: string[] | null;
  message?: string | null;
  success?: boolean;
  traceId?: string | null;
}

export type AuthTestDatabaseListData = ObjectApiResponseDto;

export type AuthVerifyOtpCreateData = AuthResponseDtoApiResponseDto;

export type DashboardAdminListData = any;

export type DashboardPurchaserListData = any;

export type DashboardUserListData = any;

export type ErpOrderTrackingListData = any;

export interface ErpOrderTrackingListParams {
  /** @format date-time */
  endDate?: Date;
  /** @format date-time */
  startDate?: Date;
}

export type Item360ListData = any;

export interface Item360ListParams {
  /** @format int32 */
  id: number;
}

export type ItemBomDeleteData = any;

export interface ItemBomDeleteParams {
  /** @format int32 */
  id: number;
}

export type ItemBomDetailData = any;

export interface ItemBomDetailParams {
  /** @format int32 */
  id: number;
}

export type ItemBomListData = any;

export interface ItemBomListParams {
  ComponentItemCode?: string;
  /** @format int32 */
  ComponentItemId?: number;
  ItemCode?: string;
  /** @format int32 */
  ItemId?: number;
}

export type ItemCategoryCreateData = any;

export type ItemCategoryDeleteData = any;

export interface ItemCategoryDeleteParams {
  /** @format int32 */
  id: number;
}

export type ItemCategoryDetailData = any;

export interface ItemCategoryDetailParams {
  /** @format int32 */
  id: number;
}

export interface ItemCategoryDto {
  code?: string | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  /** @format int32 */
  id?: number;
  name?: string | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
}

export type ItemCategoryListData = any;

export interface ItemCategoryListParams {
  Code?: string;
  Name?: string;
}

export type ItemCreateData = any;

export type ItemDeleteData = any;

export interface ItemDeleteParams {
  /** @format int32 */
  id: number;
}

export type ItemDetailData = any;

export interface ItemDetailParams {
  /** @format int32 */
  id: number;
}

export interface ItemDto {
  /** @format int32 */
  categoryId?: number;
  categoryName?: string | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  description?: string | null;
  /** @format int32 */
  id?: number;
  inActive?: boolean;
  itemCode?: string | null;
  itemImages?: ItemImageDto[] | null;
  itemName?: string | null;
  itemType?: string | null;
  /** @format int32 */
  moq?: number | null;
  purchaseItem?: boolean;
  rootCode?: string | null;
  shortCode?: string | null;
  unit?: string | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
  /** @format int32 */
  vatRate?: number;
}

export interface ItemImageDto {
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  /** @format int32 */
  id?: number;
  imageUrl?: string | null;
  /** @format int32 */
  itemId?: number | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
}

export type ItemImagesCreateData = any;

export interface ItemImagesCreateParams {
  /** @format int32 */
  itemId: number;
}

export interface ItemImagesCreatePayload {
  files?: string[];
}

export type ItemImagesListData = any;

export interface ItemImagesListParams {
  /** @format int32 */
  itemId: number;
}

export type ItemListData = any;

export interface ItemListParams {
  /** @format int32 */
  CategoryId?: number;
  ItemType?: string;
  /** @format int32 */
  Page?: number;
  /** @format int32 */
  PageSize?: number;
  SearchKeyword?: string;
}

export type ItemPurchaseHistoryListData = any;

export interface ItemPurchaseHistoryListParams {
  /** @format int32 */
  itemId: number;
}

export interface ObjectApiResponseDto {
  data?: any;
  errors?: string[] | null;
  message?: string | null;
  success?: boolean;
  traceId?: string | null;
}

export interface PORequestDto {
  /** @format double */
  approvedQuantity?: number | null;
  /** @format int32 */
  approverUserId?: number | null;
  approverUserName?: string | null;
  /** @format int32 */
  batchId?: number | null;
  /** @format int32 */
  categoryId?: number | null;
  categoryName?: string | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  createdByName?: string | null;
  /** @format int32 */
  decisionUserId?: number | null;
  decisionUserName?: string | null;
  evaluationResult?: string | null;
  /** @format int32 */
  id?: number;
  isUrgent?: boolean | null;
  itemCode?: string | null;
  /** @format int32 */
  itemId?: number;
  itemName?: string | null;
  lastPurchaseCurrency?: string | null;
  /** @format date-time */
  lastPurchaseDate?: Date | null;
  /** @format double */
  lastPurchasePrice?: number | null;
  note?: string | null;
  /** @format int32 */
  purchaserId?: number | null;
  requestStatus?: string | null;
  /** @format date-time */
  requestedDeliveryDate?: Date | null;
  /** @format double */
  requestedQuantity?: number;
  rootCode?: string | null;
  shortCode?: string | null;
  unit?: string | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
}

export type PoRequestApprovePartialUpdateData = any;

export type PoRequestAwardedSuppliersListData = any;

export type PoRequestCreateData = any;

export type PoRequestDeleteData = any;

export interface PoRequestDeleteParams {
  /** @format int32 */
  id: number;
}

export type PoRequestDeleteWithQuoteItemsDeleteData = any;

export interface PoRequestDeleteWithQuoteItemsDeleteParams {
  /** @format int32 */
  poRequestId: number;
}

export type PoRequestDetailData = any;

export type PoRequestDetailListData = any;

export interface PoRequestDetailListParams {
  /** @format int32 */
  id: number;
}

export interface PoRequestDetailParams {
  /** @format int32 */
  id: number;
}

export type PoRequestListData = any;

export interface PoRequestListParams {
  /** @format int32 */
  ApproverUserId?: number;
  /** @format int32 */
  CreatedBy?: number;
  /** @format int32 */
  DecisionUserId?: number;
  /** @format int32 */
  PurchaserId?: number;
  RequestStatus?: string;
}

export type PoRequestNegotiationSuppliersListData = any;

export type PoRequestPoRequestUserListListData = any;

export type PoRequestQuoteItemsListData = any;

export interface PoRequestQuoteItemsListParams {
  /** @format int32 */
  poRequestId: number;
}

export type PoRequestSetApprovedPartialUpdateData = any;

export interface PoRequestSetApprovedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type PoRequestSetApprovedQuantityPartialUpdateData = any;

export interface PoRequestSetApprovedQuantityPartialUpdateParams {
  /** @format int32 */
  id: number;
}

/** @format double */
export type PoRequestSetApprovedQuantityPartialUpdatePayload = number;

export type PoRequestSetPendingByUserPartialUpdateData = any;

export interface PoRequestSetPendingByUserPartialUpdateParams {
  /** @format int32 */
  createdBy: number;
}

export type PoRequestSetRejectedPartialUpdateData = any;

export interface PoRequestSetRejectedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type PoRequestStatusCountsListData = any;

export interface PoRequestStatusCountsListParams {
  /** @format int32 */
  ApproverUserId?: number;
  /** @format int32 */
  CreatedBy?: number;
  /** @format int32 */
  DecisionUserId?: number;
  /** @format int32 */
  PurchaserId?: number;
  RequestStatus?: string;
}

export type PoRequestStatusMatrixListData = any;

export type PoRequestSupplierAwardedQuoteItemsListData = any;

export interface PoRequestSupplierAwardedQuoteItemsListParams {
  /** @format int32 */
  supplierId: number;
}

export type PoRequestSupplierNegotiationQuoteItemsListData = any;

export interface PoRequestSupplierNegotiationQuoteItemsListParams {
  /** @format int32 */
  supplierId: number;
}

export type QuoteCheckoutCreateData = any;

export interface QuoteCheckoutCreateParams {
  /** @format int32 */
  quoteId: number;
}

export type QuoteCloseCreateData = any;

export interface QuoteCloseCreateParams {
  /** @format int32 */
  id: number;
}

export type QuoteDetailData = any;

export interface QuoteDetailParams {
  /** @format int32 */
  id: number;
}

export interface QuoteDto {
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  currency?: string | null;
  emailOpened?: boolean;
  /** @format date-time */
  emailOpenedAt?: Date | null;
  emailSent?: boolean;
  /** @format date-time */
  emailSentAt?: Date | null;
  /** @format int32 */
  id?: number;
  isNegotiate?: boolean;
  noteFromSupplier?: string | null;
  noteToSupplier?: string | null;
  paymentTerm?: string | null;
  quoteItems?: QuoteItemDto[] | null;
  quoteStatus?: string | null;
  responded?: boolean;
  /** @format date-time */
  respondedAt?: Date | null;
  supplier?: SupplierDto;
  supplierEmail?: string | null;
  /** @format int32 */
  supplierId?: number;
  supplierName?: string | null;
  supplierTerm?: string | null;
  /** @format int32 */
  timeoutDays?: number;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
  /** @format int32 */
  validUntil?: number | null;
  vatIncluded?: boolean;
}

export interface QuoteDtoApiResponseDto {
  data?: QuoteDto;
  errors?: string[] | null;
  message?: string | null;
  success?: boolean;
  traceId?: string | null;
}

export type QuoteFromPoRequestsCreateData = any;

export type QuoteFromQuoteItemsCreateData = any;

export type QuoteItemCreateData = any;

export type QuoteItemDeleteData = any;

export interface QuoteItemDeleteParams {
  /** @format int32 */
  id: number;
}

export type QuoteItemDetailData = any;

export interface QuoteItemDetailParams {
  /** @format int32 */
  id: number;
}

export interface QuoteItemDto {
  attachmentUrl?: string | null;
  checkedOut?: boolean;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  decisionStatus?: string | null;
  history?: QuoteItemHistoryDto[] | null;
  /** @format int32 */
  id?: number;
  item?: ItemDto;
  itemCode?: string | null;
  /** @format int32 */
  itemId?: number;
  itemName?: string | null;
  /** @format int32 */
  negotiationDeliveryDays?: number | null;
  /** @format double */
  negotiationPrice?: number | null;
  /** @format double */
  negotiationQuantity?: number | null;
  /** @format int32 */
  offeredDeliveryDays?: number | null;
  /** @format double */
  offeredPrice?: number | null;
  /** @format double */
  offeredQuantity?: number | null;
  /** @format int32 */
  poRequestId?: number;
  /** @format int32 */
  quoteId?: number;
  /** @format int32 */
  requestedDeliveryDays?: number;
  /** @format double */
  requestedPrice?: number;
  /** @format double */
  requestedQuantity?: number;
  unitName?: string | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
  /** @format double */
  vatRate?: number | null;
}

export interface QuoteItemHistoryDto {
  currency?: string | null;
  /** @format int32 */
  deliveryDays?: number | null;
  /** @format int32 */
  poRequestId?: number;
  /** @format double */
  price?: number | null;
  /** @format double */
  quantity?: number | null;
  /** @format int32 */
  sourceQuoteItemId?: number;
  /** @format date-time */
  stageDate?: Date;
  step?: string | null;
  userName?: string | null;
}

export type QuoteItemHistoryListData = any;

export interface QuoteItemHistoryListParams {
  /** @format int32 */
  quoteItemId: number;
}

export type QuoteItemListData = any;

export interface QuoteItemListParams {
  /** @format int32 */
  quoteId?: number;
}

export type QuoteItemSetAwardedPartialUpdateData = any;

export interface QuoteItemSetAwardedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type QuoteItemSetRejectedPartialUpdateData = any;

export interface QuoteItemSetRejectedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type QuoteItemUpdateData = any;

export interface QuoteItemUpdateParams {
  /** @format int32 */
  id: number;
}

export type QuoteListData = any;

export interface QuoteListParams {
  EmailOpened?: boolean;
  EmailSent?: boolean;
  QuoteStatus?: string;
  Responded?: boolean;
  /** @format int32 */
  SupplierId?: number;
}

export type QuoteNegotiatePartialUpdateData = ObjectApiResponseDto;

export type QuoteNegotiatePartialUpdateError = ObjectApiResponseDto;

export interface QuoteNegotiatePartialUpdateParams {
  /** @format int32 */
  quoteItemId: number;
}

export type QuotePublicDetailData = QuoteDtoApiResponseDto;

export type QuotePublicDetailError = ObjectApiResponseDto;

export interface QuotePublicDetailParams {
  publicId: string;
}

export type QuotePublicItemsPartialUpdateData = ObjectApiResponseDto;

export type QuotePublicItemsPartialUpdateError = ObjectApiResponseDto;

export interface QuotePublicItemsPartialUpdateParams {
  publicId: string;
  /** @format int32 */
  quoteItemId: number;
}

export type QuotePublicItemsRejectPartialUpdateData = ObjectApiResponseDto;

export type QuotePublicItemsRejectPartialUpdateError = ObjectApiResponseDto;

export interface QuotePublicItemsRejectPartialUpdateParams {
  publicId: string;
  /** @format int32 */
  quoteItemId: number;
}

export type QuotePublicPartialUpdateData = any;

export interface QuotePublicPartialUpdateParams {
  publicId: string;
}

export type QuotePublicSendConfirmationCreateData = ObjectApiResponseDto;

export type QuotePublicSendConfirmationCreateError = ObjectApiResponseDto;

export interface QuotePublicSendConfirmationCreateParams {
  publicId: string;
}

export type QuoteSendMailCreateData = any;

export interface QuoteSendMailCreateParams {
  /** @format int32 */
  id: number;
}

export type QuoteSendMailFromPoRequestCreateData = any;

export interface QuoteSendMailFromPoRequestCreateParams {
  /** @format int32 */
  id: number;
}

export type QuoteSetClosedPartialUpdateData = any;

export interface QuoteSetClosedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type QuoteSetRespondedPartialUpdateData = any;

export interface QuoteSetRespondedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export type QuoteSetViewedPartialUpdateData = any;

export interface QuoteSetViewedPartialUpdateParams {
  /** @format int32 */
  id: number;
}

export interface RequestOtpDto {
  /**
   * @format email
   * @minLength 1
   * @maxLength 100
   */
  email: string;
}

export interface SendQuoteMailFromPORequestDto {
  /**
   * @format email
   * @minLength 1
   */
  supplierEmail: string;
}

export interface SetQuoteItemNegotiateDto {
  /** @format int32 */
  negotiationDeliveryDays: number;
  /** @format double */
  negotiationPrice: number;
  /** @format double */
  negotiationQuantity: number;
}

export interface SupplierCategoryDto {
  /** @format int32 */
  categoryId?: number;
  categoryName?: string | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  /** @format int32 */
  id?: number;
  /** @format int32 */
  supplierId?: number;
}

export type SupplierCreateData = any;

export type SupplierDeleteData = any;

export interface SupplierDeleteParams {
  /** @format int32 */
  id: number;
}

export type SupplierDetailData = any;

export interface SupplierDetailParams {
  /** @format int32 */
  id: number;
}

export interface SupplierDto {
  address?: string | null;
  cardCode?: string | null;
  categories?: SupplierCategoryDto[] | null;
  city?: string | null;
  companyName?: string | null;
  contactPerson?: string | null;
  country?: string | null;
  /** @format date-time */
  createdAt?: Date;
  /** @format int32 */
  createdBy?: number;
  currency?: string | null;
  email?: string | null;
  /** @format int32 */
  id?: number;
  inActive?: boolean;
  paymentTerms?: string | null;
  phone?: string | null;
  showPaymentTerm?: boolean;
  taxNumber?: string | null;
  /** @format date-time */
  updatedAt?: Date | null;
  /** @format int32 */
  updatedBy?: number | null;
}

export type SupplierListData = any;

export interface SupplierListParams {
  /** @format int32 */
  CategoryId?: number;
}

export type SupplierWithPurchaseInfoCreateData = any;

export interface SupplierWithPurchaseInfoCreateParams {
  /** @format int32 */
  CategoryId?: number;
}

export type SupplierWithPurchaseInfoCreatePayload = string;

export interface UpdateQuoteDto {
  currency?: string | null;
  noteFromSupplier?: string | null;
  paymentTerm?: string | null;
  quoteStatus?: string | null;
  /** @format int32 */
  validUntil?: number | null;
  vatIncluded?: boolean | null;
}

export interface UpdateSingleQuoteItemDto {
  /** @format int32 */
  offeredDeliveryDays?: number | null;
  /** @format double */
  offeredPrice?: number | null;
  /** @format double */
  offeredQuantity?: number | null;
  /** @format double */
  vatRate?: number | null;
}

export interface UserInfoDto {
  email?: string | null;
  fullName?: string | null;
  /** @format int32 */
  id?: number;
  role?: string | null;
}

export interface VerifyOtpDto {
  /**
   * @minLength 6
   * @maxLength 6
   * @pattern ^\d{6}$
   */
  code: string;
  /**
   * @format email
   * @minLength 1
   * @maxLength 100
   */
  email: string;
}

export namespace Api {
  /**
   * No description
   * @tags Auth
   * @name AuthEnvironmentList
   * @request GET:/api/Auth/environment
   * @secure
   * @response `200` `AuthEnvironmentListData` OK
   */
  export namespace AuthEnvironmentList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuthEnvironmentListData;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthRequestOtpCreate
   * @request POST:/api/Auth/request-otp
   * @secure
   * @response `200` `AuthRequestOtpCreateData` OK
   */
  export namespace AuthRequestOtpCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = RequestOtpDto;
    export type RequestHeaders = {};
    export type ResponseBody = AuthRequestOtpCreateData;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthTestDatabaseList
   * @request GET:/api/Auth/test-database
   * @secure
   * @response `200` `AuthTestDatabaseListData` OK
   */
  export namespace AuthTestDatabaseList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = AuthTestDatabaseListData;
  }

  /**
   * No description
   * @tags Auth
   * @name AuthVerifyOtpCreate
   * @request POST:/api/Auth/verify-otp
   * @secure
   * @response `200` `AuthVerifyOtpCreateData` OK
   */
  export namespace AuthVerifyOtpCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = VerifyOtpDto;
    export type RequestHeaders = {};
    export type ResponseBody = AuthVerifyOtpCreateData;
  }

  /**
   * No description
   * @tags Dashboard
   * @name DashboardAdminList
   * @request GET:/api/Dashboard/admin
   * @secure
   * @response `200` `DashboardAdminListData` OK
   */
  export namespace DashboardAdminList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DashboardAdminListData;
  }

  /**
   * No description
   * @tags Dashboard
   * @name DashboardPurchaserList
   * @request GET:/api/Dashboard/purchaser
   * @secure
   * @response `200` `DashboardPurchaserListData` OK
   */
  export namespace DashboardPurchaserList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DashboardPurchaserListData;
  }

  /**
   * No description
   * @tags Dashboard
   * @name DashboardUserList
   * @request GET:/api/Dashboard/user
   * @secure
   * @response `200` `DashboardUserListData` OK
   */
  export namespace DashboardUserList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = DashboardUserListData;
  }

  /**
   * No description
   * @tags Erp
   * @name ErpOrderTrackingList
   * @request GET:/api/Erp/order-tracking
   * @secure
   * @response `200` `ErpOrderTrackingListData` OK
   */
  export namespace ErpOrderTrackingList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format date-time */
      endDate?: Date;
      /** @format date-time */
      startDate?: Date;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ErpOrderTrackingListData;
  }

  /**
   * No description
   * @tags Item
   * @name Item360List
   * @request GET:/api/Item/{id}/360
   * @secure
   * @response `200` `Item360ListData` OK
   */
  export namespace Item360List {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = Item360ListData;
  }

  /**
   * No description
   * @tags ItemBom
   * @name ItemBomDelete
   * @request DELETE:/api/ItemBom/{id}
   * @secure
   * @response `200` `ItemBomDeleteData` OK
   */
  export namespace ItemBomDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemBomDeleteData;
  }

  /**
   * No description
   * @tags ItemBom
   * @name ItemBomDetail
   * @request GET:/api/ItemBom/{id}
   * @secure
   * @response `200` `ItemBomDetailData` OK
   */
  export namespace ItemBomDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemBomDetailData;
  }

  /**
   * No description
   * @tags ItemBom
   * @name ItemBomList
   * @request GET:/api/ItemBom
   * @secure
   * @response `200` `ItemBomListData` OK
   */
  export namespace ItemBomList {
    export type RequestParams = {};
    export type RequestQuery = {
      ComponentItemCode?: string;
      /** @format int32 */
      ComponentItemId?: number;
      ItemCode?: string;
      /** @format int32 */
      ItemId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemBomListData;
  }

  /**
   * No description
   * @tags ItemCategory
   * @name ItemCategoryCreate
   * @request POST:/api/ItemCategory
   * @secure
   * @response `200` `ItemCategoryCreateData` OK
   */
  export namespace ItemCategoryCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ItemCategoryDto;
    export type RequestHeaders = {};
    export type ResponseBody = ItemCategoryCreateData;
  }

  /**
   * No description
   * @tags ItemCategory
   * @name ItemCategoryDelete
   * @request DELETE:/api/ItemCategory/{id}
   * @secure
   * @response `200` `ItemCategoryDeleteData` OK
   */
  export namespace ItemCategoryDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemCategoryDeleteData;
  }

  /**
   * No description
   * @tags ItemCategory
   * @name ItemCategoryDetail
   * @request GET:/api/ItemCategory/{id}
   * @secure
   * @response `200` `ItemCategoryDetailData` OK
   */
  export namespace ItemCategoryDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemCategoryDetailData;
  }

  /**
   * No description
   * @tags ItemCategory
   * @name ItemCategoryList
   * @request GET:/api/ItemCategory
   * @secure
   * @response `200` `ItemCategoryListData` OK
   */
  export namespace ItemCategoryList {
    export type RequestParams = {};
    export type RequestQuery = {
      Code?: string;
      Name?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemCategoryListData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemCreate
   * @request POST:/api/Item
   * @secure
   * @response `200` `ItemCreateData` OK
   */
  export namespace ItemCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ItemDto;
    export type RequestHeaders = {};
    export type ResponseBody = ItemCreateData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemDelete
   * @request DELETE:/api/Item/{id}
   * @secure
   * @response `200` `ItemDeleteData` OK
   */
  export namespace ItemDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemDeleteData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemDetail
   * @request GET:/api/Item/{id}
   * @secure
   * @response `200` `ItemDetailData` OK
   */
  export namespace ItemDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemDetailData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemImagesCreate
   * @request POST:/api/Item/{itemId}/images
   * @secure
   * @response `200` `ItemImagesCreateData` OK
   */
  export namespace ItemImagesCreate {
    export type RequestParams = {
      /** @format int32 */
      itemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = ItemImagesCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = ItemImagesCreateData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemImagesList
   * @request GET:/api/Item/{itemId}/images
   * @secure
   * @response `200` `ItemImagesListData` OK
   */
  export namespace ItemImagesList {
    export type RequestParams = {
      /** @format int32 */
      itemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemImagesListData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemList
   * @request GET:/api/Item
   * @secure
   * @response `200` `ItemListData` OK
   */
  export namespace ItemList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      CategoryId?: number;
      ItemType?: string;
      /** @format int32 */
      Page?: number;
      /** @format int32 */
      PageSize?: number;
      SearchKeyword?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemListData;
  }

  /**
   * No description
   * @tags Item
   * @name ItemPurchaseHistoryList
   * @request GET:/api/Item/{itemId}/purchase-history
   * @secure
   * @response `200` `ItemPurchaseHistoryListData` OK
   */
  export namespace ItemPurchaseHistoryList {
    export type RequestParams = {
      /** @format int32 */
      itemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ItemPurchaseHistoryListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestApprovePartialUpdate
   * @request PATCH:/api/PORequest/approve
   * @secure
   * @response `200` `PoRequestApprovePartialUpdateData` OK
   */
  export namespace PoRequestApprovePartialUpdate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApprovePORequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestApprovePartialUpdateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestAwardedSuppliersList
   * @request GET:/api/PORequest/awarded-suppliers
   * @secure
   * @response `200` `PoRequestAwardedSuppliersListData` OK
   */
  export namespace PoRequestAwardedSuppliersList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestAwardedSuppliersListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestCreate
   * @request POST:/api/PORequest
   * @secure
   * @response `200` `PoRequestCreateData` OK
   */
  export namespace PoRequestCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = PORequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestCreateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestDelete
   * @request DELETE:/api/PORequest/{id}
   * @secure
   * @response `200` `PoRequestDeleteData` OK
   */
  export namespace PoRequestDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestDeleteData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestDeleteWithQuoteItemsDelete
   * @request DELETE:/api/PORequest/delete-with-quote-items/{poRequestId}
   * @secure
   * @response `200` `PoRequestDeleteWithQuoteItemsDeleteData` OK
   */
  export namespace PoRequestDeleteWithQuoteItemsDelete {
    export type RequestParams = {
      /** @format int32 */
      poRequestId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestDeleteWithQuoteItemsDeleteData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestDetail
   * @request GET:/api/PORequest/{id}
   * @secure
   * @response `200` `PoRequestDetailData` OK
   */
  export namespace PoRequestDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestDetailData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestDetailList
   * @request GET:/api/PORequest/{id}/detail
   * @secure
   * @response `200` `PoRequestDetailListData` OK
   */
  export namespace PoRequestDetailList {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestDetailListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestList
   * @request GET:/api/PORequest
   * @secure
   * @response `200` `PoRequestListData` OK
   */
  export namespace PoRequestList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      ApproverUserId?: number;
      /** @format int32 */
      CreatedBy?: number;
      /** @format int32 */
      DecisionUserId?: number;
      /** @format int32 */
      PurchaserId?: number;
      RequestStatus?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestNegotiationSuppliersList
   * @request GET:/api/PORequest/negotiation-suppliers
   * @secure
   * @response `200` `PoRequestNegotiationSuppliersListData` OK
   */
  export namespace PoRequestNegotiationSuppliersList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestNegotiationSuppliersListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestPoRequestUserListList
   * @request GET:/api/PORequest/po-request-user-list
   * @secure
   * @response `200` `PoRequestPoRequestUserListListData` OK
   */
  export namespace PoRequestPoRequestUserListList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestPoRequestUserListListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestQuoteItemsList
   * @request GET:/api/PORequest/{poRequestId}/quote-items
   * @secure
   * @response `200` `PoRequestQuoteItemsListData` OK
   */
  export namespace PoRequestQuoteItemsList {
    export type RequestParams = {
      /** @format int32 */
      poRequestId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestQuoteItemsListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSetApprovedPartialUpdate
   * @request PATCH:/api/PORequest/{id}/set-approved
   * @secure
   * @response `200` `PoRequestSetApprovedPartialUpdateData` OK
   */
  export namespace PoRequestSetApprovedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSetApprovedPartialUpdateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSetApprovedQuantityPartialUpdate
   * @request PATCH:/api/PORequest/{id}/set-approved-quantity
   * @secure
   * @response `200` `PoRequestSetApprovedQuantityPartialUpdateData` OK
   */
  export namespace PoRequestSetApprovedQuantityPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = PoRequestSetApprovedQuantityPartialUpdatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSetApprovedQuantityPartialUpdateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSetPendingByUserPartialUpdate
   * @request PATCH:/api/PORequest/set-pending-by-user/{createdBy}
   * @secure
   * @response `200` `PoRequestSetPendingByUserPartialUpdateData` OK
   */
  export namespace PoRequestSetPendingByUserPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      createdBy: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSetPendingByUserPartialUpdateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSetRejectedPartialUpdate
   * @request PATCH:/api/PORequest/{id}/set-rejected
   * @secure
   * @response `200` `PoRequestSetRejectedPartialUpdateData` OK
   */
  export namespace PoRequestSetRejectedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSetRejectedPartialUpdateData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestStatusCountsList
   * @request GET:/api/PORequest/status-counts
   * @secure
   * @response `200` `PoRequestStatusCountsListData` OK
   */
  export namespace PoRequestStatusCountsList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      ApproverUserId?: number;
      /** @format int32 */
      CreatedBy?: number;
      /** @format int32 */
      DecisionUserId?: number;
      /** @format int32 */
      PurchaserId?: number;
      RequestStatus?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestStatusCountsListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestStatusMatrixList
   * @request GET:/api/PORequest/status-matrix
   * @secure
   * @response `200` `PoRequestStatusMatrixListData` OK
   */
  export namespace PoRequestStatusMatrixList {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestStatusMatrixListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSupplierAwardedQuoteItemsList
   * @request GET:/api/PORequest/supplier/{supplierId}/awarded-quote-items
   * @secure
   * @response `200` `PoRequestSupplierAwardedQuoteItemsListData` OK
   */
  export namespace PoRequestSupplierAwardedQuoteItemsList {
    export type RequestParams = {
      /** @format int32 */
      supplierId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSupplierAwardedQuoteItemsListData;
  }

  /**
   * No description
   * @tags PORequest
   * @name PoRequestSupplierNegotiationQuoteItemsList
   * @request GET:/api/PORequest/supplier/{supplierId}/negotiation-quote-items
   * @secure
   * @response `200` `PoRequestSupplierNegotiationQuoteItemsListData` OK
   */
  export namespace PoRequestSupplierNegotiationQuoteItemsList {
    export type RequestParams = {
      /** @format int32 */
      supplierId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = PoRequestSupplierNegotiationQuoteItemsListData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteCheckoutCreate
   * @request POST:/api/Quote/{quoteId}/checkout
   * @secure
   * @response `200` `QuoteCheckoutCreateData` OK
   */
  export namespace QuoteCheckoutCreate {
    export type RequestParams = {
      /** @format int32 */
      quoteId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteCheckoutCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteCloseCreate
   * @request POST:/api/Quote/{id}/close
   * @secure
   * @response `200` `QuoteCloseCreateData` OK
   */
  export namespace QuoteCloseCreate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteCloseCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteDetail
   * @request GET:/api/Quote/{id}
   * @secure
   * @response `200` `QuoteDetailData` OK
   */
  export namespace QuoteDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteDetailData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteFromPoRequestsCreate
   * @request POST:/api/Quote/from-po-requests
   * @secure
   * @response `200` `QuoteFromPoRequestsCreateData` OK
   */
  export namespace QuoteFromPoRequestsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AddQuoteFromPORequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteFromPoRequestsCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteFromQuoteItemsCreate
   * @request POST:/api/Quote/from-quote-items
   * @secure
   * @response `200` `QuoteFromQuoteItemsCreateData` OK
   */
  export namespace QuoteFromQuoteItemsCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = AddQuoteFromQuoteRequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteFromQuoteItemsCreateData;
  }

  /**
   * No description
   * @tags QuoteItem
   * @name QuoteItemCreate
   * @request POST:/api/QuoteItem
   * @secure
   * @response `200` `QuoteItemCreateData` OK
   */
  export namespace QuoteItemCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = QuoteItemDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemCreateData;
  }

  /**
   * No description
   * @tags QuoteItem
   * @name QuoteItemDelete
   * @request DELETE:/api/QuoteItem/{id}
   * @secure
   * @response `200` `QuoteItemDeleteData` OK
   */
  export namespace QuoteItemDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemDeleteData;
  }

  /**
   * No description
   * @tags QuoteItem
   * @name QuoteItemDetail
   * @request GET:/api/QuoteItem/{id}
   * @secure
   * @response `200` `QuoteItemDetailData` OK
   */
  export namespace QuoteItemDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemDetailData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteItemHistoryList
   * @request GET:/api/Quote/item/{quoteItemId}/history
   * @secure
   * @response `200` `QuoteItemHistoryListData` OK
   */
  export namespace QuoteItemHistoryList {
    export type RequestParams = {
      /** @format int32 */
      quoteItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemHistoryListData;
  }

  /**
   * No description
   * @tags QuoteItem
   * @name QuoteItemList
   * @request GET:/api/QuoteItem
   * @secure
   * @response `200` `QuoteItemListData` OK
   */
  export namespace QuoteItemList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      quoteId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemListData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteItemSetAwardedPartialUpdate
   * @request PATCH:/api/Quote/item/{id}/set-awarded
   * @secure
   * @response `200` `QuoteItemSetAwardedPartialUpdateData` OK
   */
  export namespace QuoteItemSetAwardedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemSetAwardedPartialUpdateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteItemSetRejectedPartialUpdate
   * @request PATCH:/api/Quote/item/{id}/set-rejected
   * @secure
   * @response `200` `QuoteItemSetRejectedPartialUpdateData` OK
   */
  export namespace QuoteItemSetRejectedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemSetRejectedPartialUpdateData;
  }

  /**
   * No description
   * @tags QuoteItem
   * @name QuoteItemUpdate
   * @request PUT:/api/QuoteItem/{id}
   * @secure
   * @response `200` `QuoteItemUpdateData` OK
   */
  export namespace QuoteItemUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = QuoteItemDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteItemUpdateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteList
   * @request GET:/api/Quote
   * @secure
   * @response `200` `QuoteListData` OK
   */
  export namespace QuoteList {
    export type RequestParams = {};
    export type RequestQuery = {
      EmailOpened?: boolean;
      EmailSent?: boolean;
      QuoteStatus?: string;
      Responded?: boolean;
      /** @format int32 */
      SupplierId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteListData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteNegotiatePartialUpdate
   * @request PATCH:/api/Quote/{quoteItemId}/negotiate
   * @secure
   * @response `200` `QuoteNegotiatePartialUpdateData` OK
   * @response `400` `ObjectApiResponseDto` Bad Request
   * @response `404` `ObjectApiResponseDto` Not Found
   * @response `500` `ObjectApiResponseDto` Internal Server Error
   */
  export namespace QuoteNegotiatePartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      quoteItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = SetQuoteItemNegotiateDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteNegotiatePartialUpdateData;
  }

  /**
   * No description
   * @tags QuotePublic
   * @name QuotePublicDetail
   * @request GET:/api/QuotePublic/{publicId}
   * @secure
   * @response `200` `QuotePublicDetailData` OK
   * @response `404` `ObjectApiResponseDto` Not Found
   * @response `500` `ObjectApiResponseDto` Internal Server Error
   */
  export namespace QuotePublicDetail {
    export type RequestParams = {
      publicId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuotePublicDetailData;
  }

  /**
   * No description
   * @tags QuotePublic
   * @name QuotePublicItemsPartialUpdate
   * @request PATCH:/api/QuotePublic/{publicId}/items/{quoteItemId}
   * @secure
   * @response `200` `QuotePublicItemsPartialUpdateData` OK
   * @response `400` `ObjectApiResponseDto` Bad Request
   * @response `404` `ObjectApiResponseDto` Not Found
   * @response `500` `ObjectApiResponseDto` Internal Server Error
   */
  export namespace QuotePublicItemsPartialUpdate {
    export type RequestParams = {
      publicId: string;
      /** @format int32 */
      quoteItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateSingleQuoteItemDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuotePublicItemsPartialUpdateData;
  }

  /**
   * No description
   * @tags QuotePublic
   * @name QuotePublicItemsRejectPartialUpdate
   * @request PATCH:/api/QuotePublic/{publicId}/items/{quoteItemId}/reject
   * @secure
   * @response `200` `QuotePublicItemsRejectPartialUpdateData` OK
   * @response `400` `ObjectApiResponseDto` Bad Request
   * @response `404` `ObjectApiResponseDto` Not Found
   * @response `500` `ObjectApiResponseDto` Internal Server Error
   */
  export namespace QuotePublicItemsRejectPartialUpdate {
    export type RequestParams = {
      publicId: string;
      /** @format int32 */
      quoteItemId: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuotePublicItemsRejectPartialUpdateData;
  }

  /**
   * No description
   * @tags QuotePublic
   * @name QuotePublicPartialUpdate
   * @request PATCH:/api/QuotePublic/{publicId}
   * @secure
   * @response `200` `QuotePublicPartialUpdateData` OK
   */
  export namespace QuotePublicPartialUpdate {
    export type RequestParams = {
      publicId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = UpdateQuoteDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuotePublicPartialUpdateData;
  }

  /**
   * No description
   * @tags QuotePublic
   * @name QuotePublicSendConfirmationCreate
   * @request POST:/api/QuotePublic/{publicId}/send-confirmation
   * @secure
   * @response `200` `QuotePublicSendConfirmationCreateData` OK
   * @response `400` `ObjectApiResponseDto` Bad Request
   * @response `404` `ObjectApiResponseDto` Not Found
   */
  export namespace QuotePublicSendConfirmationCreate {
    export type RequestParams = {
      publicId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuotePublicSendConfirmationCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteSendMailCreate
   * @request POST:/api/Quote/{id}/send-mail
   * @secure
   * @response `200` `QuoteSendMailCreateData` OK
   */
  export namespace QuoteSendMailCreate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteSendMailCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteSendMailFromPoRequestCreate
   * @request POST:/api/Quote/{id}/send-mail-from-po-request
   * @secure
   * @response `200` `QuoteSendMailFromPoRequestCreateData` OK
   */
  export namespace QuoteSendMailFromPoRequestCreate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = SendQuoteMailFromPORequestDto;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteSendMailFromPoRequestCreateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteSetClosedPartialUpdate
   * @request PATCH:/api/Quote/{id}/set-closed
   * @secure
   * @response `200` `QuoteSetClosedPartialUpdateData` OK
   */
  export namespace QuoteSetClosedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteSetClosedPartialUpdateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteSetRespondedPartialUpdate
   * @request PATCH:/api/Quote/{id}/set-responded
   * @secure
   * @response `200` `QuoteSetRespondedPartialUpdateData` OK
   */
  export namespace QuoteSetRespondedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteSetRespondedPartialUpdateData;
  }

  /**
   * No description
   * @tags Quote
   * @name QuoteSetViewedPartialUpdate
   * @request PATCH:/api/Quote/{id}/set-viewed
   * @secure
   * @response `200` `QuoteSetViewedPartialUpdateData` OK
   */
  export namespace QuoteSetViewedPartialUpdate {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = QuoteSetViewedPartialUpdateData;
  }

  /**
   * No description
   * @tags Supplier
   * @name SupplierCreate
   * @request POST:/api/Supplier
   * @secure
   * @response `200` `SupplierCreateData` OK
   */
  export namespace SupplierCreate {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = SupplierDto;
    export type RequestHeaders = {};
    export type ResponseBody = SupplierCreateData;
  }

  /**
   * No description
   * @tags Supplier
   * @name SupplierDelete
   * @request DELETE:/api/Supplier/{id}
   * @secure
   * @response `200` `SupplierDeleteData` OK
   */
  export namespace SupplierDelete {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupplierDeleteData;
  }

  /**
   * No description
   * @tags Supplier
   * @name SupplierDetail
   * @request GET:/api/Supplier/{id}
   * @secure
   * @response `200` `SupplierDetailData` OK
   */
  export namespace SupplierDetail {
    export type RequestParams = {
      /** @format int32 */
      id: number;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupplierDetailData;
  }

  /**
   * No description
   * @tags Supplier
   * @name SupplierList
   * @request GET:/api/Supplier
   * @secure
   * @response `200` `SupplierListData` OK
   */
  export namespace SupplierList {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      CategoryId?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = SupplierListData;
  }

  /**
   * No description
   * @tags Supplier
   * @name SupplierWithPurchaseInfoCreate
   * @request POST:/api/Supplier/with-purchase-info
   * @secure
   * @response `200` `SupplierWithPurchaseInfoCreateData` OK
   */
  export namespace SupplierWithPurchaseInfoCreate {
    export type RequestParams = {};
    export type RequestQuery = {
      /** @format int32 */
      CategoryId?: number;
    };
    export type RequestBody = SupplierWithPurchaseInfoCreatePayload;
    export type RequestHeaders = {};
    export type ResponseBody = SupplierWithPurchaseInfoCreateData;
  }
}

import type {
  AxiosInstance,
  AxiosRequestConfig,
  HeadersDefaults,
  ResponseType,
} from "axios";
import axios from "axios";

export type QueryParamsType = Record<string | number, any>;

export interface FullRequestParams
  extends Omit<AxiosRequestConfig, "data" | "params" | "url" | "responseType"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseType;
  /** request body */
  body?: unknown;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown>
  extends Omit<AxiosRequestConfig, "data" | "cancelToken"> {
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<AxiosRequestConfig | void> | AxiosRequestConfig | void;
  secure?: boolean;
  format?: ResponseType;
}

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public instance: AxiosInstance;
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private secure?: boolean;
  private format?: ResponseType;

  constructor({
    securityWorker,
    secure,
    format,
    ...axiosConfig
  }: ApiConfig<SecurityDataType> = {}) {
    this.instance = axios.create({
      ...axiosConfig,
      baseURL: axiosConfig.baseURL || "",
    });
    this.secure = secure;
    this.format = format;
    this.securityWorker = securityWorker;
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected mergeRequestParams(
    params1: AxiosRequestConfig,
    params2?: AxiosRequestConfig,
  ): AxiosRequestConfig {
    const method = params1.method || (params2 && params2.method);

    return {
      ...this.instance.defaults,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...((method &&
          this.instance.defaults.headers[
            method.toLowerCase() as keyof HeadersDefaults
          ]) ||
          {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected stringifyFormItem(formItem: unknown) {
    if (typeof formItem === "object" && formItem !== null) {
      return JSON.stringify(formItem);
    } else {
      return `${formItem}`;
    }
  }

  protected createFormData(input: Record<string, unknown>): FormData {
    if (input instanceof FormData) {
      return input;
    }
    return Object.keys(input || {}).reduce((formData, key) => {
      const property = input[key];
      const propertyContent: any[] =
        property instanceof Array ? property : [property];

      for (const formItem of propertyContent) {
        const isFileType = formItem instanceof Blob || formItem instanceof File;
        formData.append(
          key,
          isFileType ? formItem : this.stringifyFormItem(formItem),
        );
      }

      return formData;
    }, new FormData());
  }

  public request = async <T = any, _E = any>({
    secure,
    path,
    type,
    query,
    format,
    body,
    ...params
  }: FullRequestParams): Promise<T> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const responseFormat = format || this.format || undefined;

    if (
      type === ContentType.FormData &&
      body &&
      body !== null &&
      typeof body === "object"
    ) {
      body = this.createFormData(body as Record<string, unknown>);
    }

    if (
      type === ContentType.Text &&
      body &&
      body !== null &&
      typeof body !== "string"
    ) {
      body = JSON.stringify(body);
    }

    return this.instance
      .request({
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type ? { "Content-Type": type } : {}),
        },
        params: query,
        responseType: responseFormat,
        data: body,
        url: path,
      })
      .then((response) => response.data);
  };
}

/**
 * @title SmartBuy API (Development)
 * @version v1
 *
 * SmartBuy Satın Alma Yönetimi API - Development Environment
 */
export class Api<SecurityDataType extends unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  api = {
    /**
     * No description
     *
     * @tags Auth
     * @name AuthEnvironmentList
     * @request GET:/api/Auth/environment
     * @secure
     * @response `200` `AuthEnvironmentListData` OK
     */
    authEnvironmentList: (params: RequestParams = {}) =>
      this.http.request<AuthEnvironmentListData, any>({
        path: `/api/Auth/environment`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthRequestOtpCreate
     * @request POST:/api/Auth/request-otp
     * @secure
     * @response `200` `AuthRequestOtpCreateData` OK
     */
    authRequestOtpCreate: (data: RequestOtpDto, params: RequestParams = {}) =>
      this.http.request<AuthRequestOtpCreateData, any>({
        path: `/api/Auth/request-otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthTestDatabaseList
     * @request GET:/api/Auth/test-database
     * @secure
     * @response `200` `AuthTestDatabaseListData` OK
     */
    authTestDatabaseList: (params: RequestParams = {}) =>
      this.http.request<AuthTestDatabaseListData, any>({
        path: `/api/Auth/test-database`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Auth
     * @name AuthVerifyOtpCreate
     * @request POST:/api/Auth/verify-otp
     * @secure
     * @response `200` `AuthVerifyOtpCreateData` OK
     */
    authVerifyOtpCreate: (data: VerifyOtpDto, params: RequestParams = {}) =>
      this.http.request<AuthVerifyOtpCreateData, any>({
        path: `/api/Auth/verify-otp`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name DashboardAdminList
     * @request GET:/api/Dashboard/admin
     * @secure
     * @response `200` `DashboardAdminListData` OK
     */
    dashboardAdminList: (params: RequestParams = {}) =>
      this.http.request<DashboardAdminListData, any>({
        path: `/api/Dashboard/admin`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name DashboardPurchaserList
     * @request GET:/api/Dashboard/purchaser
     * @secure
     * @response `200` `DashboardPurchaserListData` OK
     */
    dashboardPurchaserList: (params: RequestParams = {}) =>
      this.http.request<DashboardPurchaserListData, any>({
        path: `/api/Dashboard/purchaser`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Dashboard
     * @name DashboardUserList
     * @request GET:/api/Dashboard/user
     * @secure
     * @response `200` `DashboardUserListData` OK
     */
    dashboardUserList: (params: RequestParams = {}) =>
      this.http.request<DashboardUserListData, any>({
        path: `/api/Dashboard/user`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Erp
     * @name ErpOrderTrackingList
     * @request GET:/api/Erp/order-tracking
     * @secure
     * @response `200` `ErpOrderTrackingListData` OK
     */
    erpOrderTrackingList: (
      query: ErpOrderTrackingListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ErpOrderTrackingListData, any>({
        path: `/api/Erp/order-tracking`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name Item360List
     * @request GET:/api/Item/{id}/360
     * @secure
     * @response `200` `Item360ListData` OK
     */
    item360List: (
      { id, ...query }: Item360ListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<Item360ListData, any>({
        path: `/api/Item/${id}/360`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemBom
     * @name ItemBomDelete
     * @request DELETE:/api/ItemBom/{id}
     * @secure
     * @response `200` `ItemBomDeleteData` OK
     */
    itemBomDelete: (
      { id, ...query }: ItemBomDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemBomDeleteData, any>({
        path: `/api/ItemBom/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemBom
     * @name ItemBomDetail
     * @request GET:/api/ItemBom/{id}
     * @secure
     * @response `200` `ItemBomDetailData` OK
     */
    itemBomDetail: (
      { id, ...query }: ItemBomDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemBomDetailData, any>({
        path: `/api/ItemBom/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemBom
     * @name ItemBomList
     * @request GET:/api/ItemBom
     * @secure
     * @response `200` `ItemBomListData` OK
     */
    itemBomList: (query: ItemBomListParams, params: RequestParams = {}) =>
      this.http.request<ItemBomListData, any>({
        path: `/api/ItemBom`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemCategory
     * @name ItemCategoryCreate
     * @request POST:/api/ItemCategory
     * @secure
     * @response `200` `ItemCategoryCreateData` OK
     */
    itemCategoryCreate: (data: ItemCategoryDto, params: RequestParams = {}) =>
      this.http.request<ItemCategoryCreateData, any>({
        path: `/api/ItemCategory`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemCategory
     * @name ItemCategoryDelete
     * @request DELETE:/api/ItemCategory/{id}
     * @secure
     * @response `200` `ItemCategoryDeleteData` OK
     */
    itemCategoryDelete: (
      { id, ...query }: ItemCategoryDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemCategoryDeleteData, any>({
        path: `/api/ItemCategory/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemCategory
     * @name ItemCategoryDetail
     * @request GET:/api/ItemCategory/{id}
     * @secure
     * @response `200` `ItemCategoryDetailData` OK
     */
    itemCategoryDetail: (
      { id, ...query }: ItemCategoryDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemCategoryDetailData, any>({
        path: `/api/ItemCategory/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ItemCategory
     * @name ItemCategoryList
     * @request GET:/api/ItemCategory
     * @secure
     * @response `200` `ItemCategoryListData` OK
     */
    itemCategoryList: (
      query: ItemCategoryListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemCategoryListData, any>({
        path: `/api/ItemCategory`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemCreate
     * @request POST:/api/Item
     * @secure
     * @response `200` `ItemCreateData` OK
     */
    itemCreate: (data: ItemDto, params: RequestParams = {}) =>
      this.http.request<ItemCreateData, any>({
        path: `/api/Item`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemDelete
     * @request DELETE:/api/Item/{id}
     * @secure
     * @response `200` `ItemDeleteData` OK
     */
    itemDelete: (
      { id, ...query }: ItemDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemDeleteData, any>({
        path: `/api/Item/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemDetail
     * @request GET:/api/Item/{id}
     * @secure
     * @response `200` `ItemDetailData` OK
     */
    itemDetail: (
      { id, ...query }: ItemDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemDetailData, any>({
        path: `/api/Item/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemImagesCreate
     * @request POST:/api/Item/{itemId}/images
     * @secure
     * @response `200` `ItemImagesCreateData` OK
     */
    itemImagesCreate: (
      { itemId, ...query }: ItemImagesCreateParams,
      data: ItemImagesCreatePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemImagesCreateData, any>({
        path: `/api/Item/${itemId}/images`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemImagesList
     * @request GET:/api/Item/{itemId}/images
     * @secure
     * @response `200` `ItemImagesListData` OK
     */
    itemImagesList: (
      { itemId, ...query }: ItemImagesListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemImagesListData, any>({
        path: `/api/Item/${itemId}/images`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemList
     * @request GET:/api/Item
     * @secure
     * @response `200` `ItemListData` OK
     */
    itemList: (query: ItemListParams, params: RequestParams = {}) =>
      this.http.request<ItemListData, any>({
        path: `/api/Item`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Item
     * @name ItemPurchaseHistoryList
     * @request GET:/api/Item/{itemId}/purchase-history
     * @secure
     * @response `200` `ItemPurchaseHistoryListData` OK
     */
    itemPurchaseHistoryList: (
      { itemId, ...query }: ItemPurchaseHistoryListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<ItemPurchaseHistoryListData, any>({
        path: `/api/Item/${itemId}/purchase-history`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestApprovePartialUpdate
     * @request PATCH:/api/PORequest/approve
     * @secure
     * @response `200` `PoRequestApprovePartialUpdateData` OK
     */
    poRequestApprovePartialUpdate: (
      data: ApprovePORequestDto,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestApprovePartialUpdateData, any>({
        path: `/api/PORequest/approve`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestAwardedSuppliersList
     * @request GET:/api/PORequest/awarded-suppliers
     * @secure
     * @response `200` `PoRequestAwardedSuppliersListData` OK
     */
    poRequestAwardedSuppliersList: (params: RequestParams = {}) =>
      this.http.request<PoRequestAwardedSuppliersListData, any>({
        path: `/api/PORequest/awarded-suppliers`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestCreate
     * @request POST:/api/PORequest
     * @secure
     * @response `200` `PoRequestCreateData` OK
     */
    poRequestCreate: (data: PORequestDto, params: RequestParams = {}) =>
      this.http.request<PoRequestCreateData, any>({
        path: `/api/PORequest`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestDelete
     * @request DELETE:/api/PORequest/{id}
     * @secure
     * @response `200` `PoRequestDeleteData` OK
     */
    poRequestDelete: (
      { id, ...query }: PoRequestDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestDeleteData, any>({
        path: `/api/PORequest/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestDeleteWithQuoteItemsDelete
     * @request DELETE:/api/PORequest/delete-with-quote-items/{poRequestId}
     * @secure
     * @response `200` `PoRequestDeleteWithQuoteItemsDeleteData` OK
     */
    poRequestDeleteWithQuoteItemsDelete: (
      { poRequestId, ...query }: PoRequestDeleteWithQuoteItemsDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestDeleteWithQuoteItemsDeleteData, any>({
        path: `/api/PORequest/delete-with-quote-items/${poRequestId}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestDetail
     * @request GET:/api/PORequest/{id}
     * @secure
     * @response `200` `PoRequestDetailData` OK
     */
    poRequestDetail: (
      { id, ...query }: PoRequestDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestDetailData, any>({
        path: `/api/PORequest/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestDetailList
     * @request GET:/api/PORequest/{id}/detail
     * @secure
     * @response `200` `PoRequestDetailListData` OK
     */
    poRequestDetailList: (
      { id, ...query }: PoRequestDetailListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestDetailListData, any>({
        path: `/api/PORequest/${id}/detail`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestList
     * @request GET:/api/PORequest
     * @secure
     * @response `200` `PoRequestListData` OK
     */
    poRequestList: (query: PoRequestListParams, params: RequestParams = {}) =>
      this.http.request<PoRequestListData, any>({
        path: `/api/PORequest`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestNegotiationSuppliersList
     * @request GET:/api/PORequest/negotiation-suppliers
     * @secure
     * @response `200` `PoRequestNegotiationSuppliersListData` OK
     */
    poRequestNegotiationSuppliersList: (params: RequestParams = {}) =>
      this.http.request<PoRequestNegotiationSuppliersListData, any>({
        path: `/api/PORequest/negotiation-suppliers`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestPoRequestUserListList
     * @request GET:/api/PORequest/po-request-user-list
     * @secure
     * @response `200` `PoRequestPoRequestUserListListData` OK
     */
    poRequestPoRequestUserListList: (params: RequestParams = {}) =>
      this.http.request<PoRequestPoRequestUserListListData, any>({
        path: `/api/PORequest/po-request-user-list`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestQuoteItemsList
     * @request GET:/api/PORequest/{poRequestId}/quote-items
     * @secure
     * @response `200` `PoRequestQuoteItemsListData` OK
     */
    poRequestQuoteItemsList: (
      { poRequestId, ...query }: PoRequestQuoteItemsListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestQuoteItemsListData, any>({
        path: `/api/PORequest/${poRequestId}/quote-items`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSetApprovedPartialUpdate
     * @request PATCH:/api/PORequest/{id}/set-approved
     * @secure
     * @response `200` `PoRequestSetApprovedPartialUpdateData` OK
     */
    poRequestSetApprovedPartialUpdate: (
      { id, ...query }: PoRequestSetApprovedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSetApprovedPartialUpdateData, any>({
        path: `/api/PORequest/${id}/set-approved`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSetApprovedQuantityPartialUpdate
     * @request PATCH:/api/PORequest/{id}/set-approved-quantity
     * @secure
     * @response `200` `PoRequestSetApprovedQuantityPartialUpdateData` OK
     */
    poRequestSetApprovedQuantityPartialUpdate: (
      { id, ...query }: PoRequestSetApprovedQuantityPartialUpdateParams,
      data: PoRequestSetApprovedQuantityPartialUpdatePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSetApprovedQuantityPartialUpdateData, any>({
        path: `/api/PORequest/${id}/set-approved-quantity`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSetPendingByUserPartialUpdate
     * @request PATCH:/api/PORequest/set-pending-by-user/{createdBy}
     * @secure
     * @response `200` `PoRequestSetPendingByUserPartialUpdateData` OK
     */
    poRequestSetPendingByUserPartialUpdate: (
      { createdBy, ...query }: PoRequestSetPendingByUserPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSetPendingByUserPartialUpdateData, any>({
        path: `/api/PORequest/set-pending-by-user/${createdBy}`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSetRejectedPartialUpdate
     * @request PATCH:/api/PORequest/{id}/set-rejected
     * @secure
     * @response `200` `PoRequestSetRejectedPartialUpdateData` OK
     */
    poRequestSetRejectedPartialUpdate: (
      { id, ...query }: PoRequestSetRejectedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSetRejectedPartialUpdateData, any>({
        path: `/api/PORequest/${id}/set-rejected`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestStatusCountsList
     * @request GET:/api/PORequest/status-counts
     * @secure
     * @response `200` `PoRequestStatusCountsListData` OK
     */
    poRequestStatusCountsList: (
      query: PoRequestStatusCountsListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestStatusCountsListData, any>({
        path: `/api/PORequest/status-counts`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestStatusMatrixList
     * @request GET:/api/PORequest/status-matrix
     * @secure
     * @response `200` `PoRequestStatusMatrixListData` OK
     */
    poRequestStatusMatrixList: (params: RequestParams = {}) =>
      this.http.request<PoRequestStatusMatrixListData, any>({
        path: `/api/PORequest/status-matrix`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSupplierAwardedQuoteItemsList
     * @request GET:/api/PORequest/supplier/{supplierId}/awarded-quote-items
     * @secure
     * @response `200` `PoRequestSupplierAwardedQuoteItemsListData` OK
     */
    poRequestSupplierAwardedQuoteItemsList: (
      { supplierId, ...query }: PoRequestSupplierAwardedQuoteItemsListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSupplierAwardedQuoteItemsListData, any>({
        path: `/api/PORequest/supplier/${supplierId}/awarded-quote-items`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags PORequest
     * @name PoRequestSupplierNegotiationQuoteItemsList
     * @request GET:/api/PORequest/supplier/{supplierId}/negotiation-quote-items
     * @secure
     * @response `200` `PoRequestSupplierNegotiationQuoteItemsListData` OK
     */
    poRequestSupplierNegotiationQuoteItemsList: (
      {
        supplierId,
        ...query
      }: PoRequestSupplierNegotiationQuoteItemsListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<PoRequestSupplierNegotiationQuoteItemsListData, any>({
        path: `/api/PORequest/supplier/${supplierId}/negotiation-quote-items`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteCheckoutCreate
     * @request POST:/api/Quote/{quoteId}/checkout
     * @secure
     * @response `200` `QuoteCheckoutCreateData` OK
     */
    quoteCheckoutCreate: (
      { quoteId, ...query }: QuoteCheckoutCreateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteCheckoutCreateData, any>({
        path: `/api/Quote/${quoteId}/checkout`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteCloseCreate
     * @request POST:/api/Quote/{id}/close
     * @secure
     * @response `200` `QuoteCloseCreateData` OK
     */
    quoteCloseCreate: (
      { id, ...query }: QuoteCloseCreateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteCloseCreateData, any>({
        path: `/api/Quote/${id}/close`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteDetail
     * @request GET:/api/Quote/{id}
     * @secure
     * @response `200` `QuoteDetailData` OK
     */
    quoteDetail: (
      { id, ...query }: QuoteDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteDetailData, any>({
        path: `/api/Quote/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteFromPoRequestsCreate
     * @request POST:/api/Quote/from-po-requests
     * @secure
     * @response `200` `QuoteFromPoRequestsCreateData` OK
     */
    quoteFromPoRequestsCreate: (
      data: AddQuoteFromPORequestDto,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteFromPoRequestsCreateData, any>({
        path: `/api/Quote/from-po-requests`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteFromQuoteItemsCreate
     * @request POST:/api/Quote/from-quote-items
     * @secure
     * @response `200` `QuoteFromQuoteItemsCreateData` OK
     */
    quoteFromQuoteItemsCreate: (
      data: AddQuoteFromQuoteRequestDto,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteFromQuoteItemsCreateData, any>({
        path: `/api/Quote/from-quote-items`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteItem
     * @name QuoteItemCreate
     * @request POST:/api/QuoteItem
     * @secure
     * @response `200` `QuoteItemCreateData` OK
     */
    quoteItemCreate: (data: QuoteItemDto, params: RequestParams = {}) =>
      this.http.request<QuoteItemCreateData, any>({
        path: `/api/QuoteItem`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteItem
     * @name QuoteItemDelete
     * @request DELETE:/api/QuoteItem/{id}
     * @secure
     * @response `200` `QuoteItemDeleteData` OK
     */
    quoteItemDelete: (
      { id, ...query }: QuoteItemDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemDeleteData, any>({
        path: `/api/QuoteItem/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteItem
     * @name QuoteItemDetail
     * @request GET:/api/QuoteItem/{id}
     * @secure
     * @response `200` `QuoteItemDetailData` OK
     */
    quoteItemDetail: (
      { id, ...query }: QuoteItemDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemDetailData, any>({
        path: `/api/QuoteItem/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteItemHistoryList
     * @request GET:/api/Quote/item/{quoteItemId}/history
     * @secure
     * @response `200` `QuoteItemHistoryListData` OK
     */
    quoteItemHistoryList: (
      { quoteItemId, ...query }: QuoteItemHistoryListParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemHistoryListData, any>({
        path: `/api/Quote/item/${quoteItemId}/history`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteItem
     * @name QuoteItemList
     * @request GET:/api/QuoteItem
     * @secure
     * @response `200` `QuoteItemListData` OK
     */
    quoteItemList: (query: QuoteItemListParams, params: RequestParams = {}) =>
      this.http.request<QuoteItemListData, any>({
        path: `/api/QuoteItem`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteItemSetAwardedPartialUpdate
     * @request PATCH:/api/Quote/item/{id}/set-awarded
     * @secure
     * @response `200` `QuoteItemSetAwardedPartialUpdateData` OK
     */
    quoteItemSetAwardedPartialUpdate: (
      { id, ...query }: QuoteItemSetAwardedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemSetAwardedPartialUpdateData, any>({
        path: `/api/Quote/item/${id}/set-awarded`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteItemSetRejectedPartialUpdate
     * @request PATCH:/api/Quote/item/{id}/set-rejected
     * @secure
     * @response `200` `QuoteItemSetRejectedPartialUpdateData` OK
     */
    quoteItemSetRejectedPartialUpdate: (
      { id, ...query }: QuoteItemSetRejectedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemSetRejectedPartialUpdateData, any>({
        path: `/api/Quote/item/${id}/set-rejected`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuoteItem
     * @name QuoteItemUpdate
     * @request PUT:/api/QuoteItem/{id}
     * @secure
     * @response `200` `QuoteItemUpdateData` OK
     */
    quoteItemUpdate: (
      { id, ...query }: QuoteItemUpdateParams,
      data: QuoteItemDto,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteItemUpdateData, any>({
        path: `/api/QuoteItem/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteList
     * @request GET:/api/Quote
     * @secure
     * @response `200` `QuoteListData` OK
     */
    quoteList: (query: QuoteListParams, params: RequestParams = {}) =>
      this.http.request<QuoteListData, any>({
        path: `/api/Quote`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteNegotiatePartialUpdate
     * @request PATCH:/api/Quote/{quoteItemId}/negotiate
     * @secure
     * @response `200` `QuoteNegotiatePartialUpdateData` OK
     * @response `400` `ObjectApiResponseDto` Bad Request
     * @response `404` `ObjectApiResponseDto` Not Found
     * @response `500` `ObjectApiResponseDto` Internal Server Error
     */
    quoteNegotiatePartialUpdate: (
      { quoteItemId, ...query }: QuoteNegotiatePartialUpdateParams,
      data: SetQuoteItemNegotiateDto,
      params: RequestParams = {},
    ) =>
      this.http.request<
        QuoteNegotiatePartialUpdateData,
        QuoteNegotiatePartialUpdateError
      >({
        path: `/api/Quote/${quoteItemId}/negotiate`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuotePublic
     * @name QuotePublicDetail
     * @request GET:/api/QuotePublic/{publicId}
     * @secure
     * @response `200` `QuotePublicDetailData` OK
     * @response `404` `ObjectApiResponseDto` Not Found
     * @response `500` `ObjectApiResponseDto` Internal Server Error
     */
    quotePublicDetail: (
      { publicId, ...query }: QuotePublicDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuotePublicDetailData, QuotePublicDetailError>({
        path: `/api/QuotePublic/${publicId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuotePublic
     * @name QuotePublicItemsPartialUpdate
     * @request PATCH:/api/QuotePublic/{publicId}/items/{quoteItemId}
     * @secure
     * @response `200` `QuotePublicItemsPartialUpdateData` OK
     * @response `400` `ObjectApiResponseDto` Bad Request
     * @response `404` `ObjectApiResponseDto` Not Found
     * @response `500` `ObjectApiResponseDto` Internal Server Error
     */
    quotePublicItemsPartialUpdate: (
      { publicId, quoteItemId, ...query }: QuotePublicItemsPartialUpdateParams,
      data: UpdateSingleQuoteItemDto,
      params: RequestParams = {},
    ) =>
      this.http.request<
        QuotePublicItemsPartialUpdateData,
        QuotePublicItemsPartialUpdateError
      >({
        path: `/api/QuotePublic/${publicId}/items/${quoteItemId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuotePublic
     * @name QuotePublicItemsRejectPartialUpdate
     * @request PATCH:/api/QuotePublic/{publicId}/items/{quoteItemId}/reject
     * @secure
     * @response `200` `QuotePublicItemsRejectPartialUpdateData` OK
     * @response `400` `ObjectApiResponseDto` Bad Request
     * @response `404` `ObjectApiResponseDto` Not Found
     * @response `500` `ObjectApiResponseDto` Internal Server Error
     */
    quotePublicItemsRejectPartialUpdate: (
      {
        publicId,
        quoteItemId,
        ...query
      }: QuotePublicItemsRejectPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<
        QuotePublicItemsRejectPartialUpdateData,
        QuotePublicItemsRejectPartialUpdateError
      >({
        path: `/api/QuotePublic/${publicId}/items/${quoteItemId}/reject`,
        method: "PATCH",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuotePublic
     * @name QuotePublicPartialUpdate
     * @request PATCH:/api/QuotePublic/{publicId}
     * @secure
     * @response `200` `QuotePublicPartialUpdateData` OK
     */
    quotePublicPartialUpdate: (
      { publicId, ...query }: QuotePublicPartialUpdateParams,
      data: UpdateQuoteDto,
      params: RequestParams = {},
    ) =>
      this.http.request<QuotePublicPartialUpdateData, any>({
        path: `/api/QuotePublic/${publicId}`,
        method: "PATCH",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags QuotePublic
     * @name QuotePublicSendConfirmationCreate
     * @request POST:/api/QuotePublic/{publicId}/send-confirmation
     * @secure
     * @response `200` `QuotePublicSendConfirmationCreateData` OK
     * @response `400` `ObjectApiResponseDto` Bad Request
     * @response `404` `ObjectApiResponseDto` Not Found
     */
    quotePublicSendConfirmationCreate: (
      { publicId, ...query }: QuotePublicSendConfirmationCreateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<
        QuotePublicSendConfirmationCreateData,
        QuotePublicSendConfirmationCreateError
      >({
        path: `/api/QuotePublic/${publicId}/send-confirmation`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteSendMailCreate
     * @request POST:/api/Quote/{id}/send-mail
     * @secure
     * @response `200` `QuoteSendMailCreateData` OK
     */
    quoteSendMailCreate: (
      { id, ...query }: QuoteSendMailCreateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteSendMailCreateData, any>({
        path: `/api/Quote/${id}/send-mail`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteSendMailFromPoRequestCreate
     * @request POST:/api/Quote/{id}/send-mail-from-po-request
     * @secure
     * @response `200` `QuoteSendMailFromPoRequestCreateData` OK
     */
    quoteSendMailFromPoRequestCreate: (
      { id, ...query }: QuoteSendMailFromPoRequestCreateParams,
      data: SendQuoteMailFromPORequestDto,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteSendMailFromPoRequestCreateData, any>({
        path: `/api/Quote/${id}/send-mail-from-po-request`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteSetClosedPartialUpdate
     * @request PATCH:/api/Quote/{id}/set-closed
     * @secure
     * @response `200` `QuoteSetClosedPartialUpdateData` OK
     */
    quoteSetClosedPartialUpdate: (
      { id, ...query }: QuoteSetClosedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteSetClosedPartialUpdateData, any>({
        path: `/api/Quote/${id}/set-closed`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteSetRespondedPartialUpdate
     * @request PATCH:/api/Quote/{id}/set-responded
     * @secure
     * @response `200` `QuoteSetRespondedPartialUpdateData` OK
     */
    quoteSetRespondedPartialUpdate: (
      { id, ...query }: QuoteSetRespondedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteSetRespondedPartialUpdateData, any>({
        path: `/api/Quote/${id}/set-responded`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Quote
     * @name QuoteSetViewedPartialUpdate
     * @request PATCH:/api/Quote/{id}/set-viewed
     * @secure
     * @response `200` `QuoteSetViewedPartialUpdateData` OK
     */
    quoteSetViewedPartialUpdate: (
      { id, ...query }: QuoteSetViewedPartialUpdateParams,
      params: RequestParams = {},
    ) =>
      this.http.request<QuoteSetViewedPartialUpdateData, any>({
        path: `/api/Quote/${id}/set-viewed`,
        method: "PATCH",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supplier
     * @name SupplierCreate
     * @request POST:/api/Supplier
     * @secure
     * @response `200` `SupplierCreateData` OK
     */
    supplierCreate: (data: SupplierDto, params: RequestParams = {}) =>
      this.http.request<SupplierCreateData, any>({
        path: `/api/Supplier`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supplier
     * @name SupplierDelete
     * @request DELETE:/api/Supplier/{id}
     * @secure
     * @response `200` `SupplierDeleteData` OK
     */
    supplierDelete: (
      { id, ...query }: SupplierDeleteParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SupplierDeleteData, any>({
        path: `/api/Supplier/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supplier
     * @name SupplierDetail
     * @request GET:/api/Supplier/{id}
     * @secure
     * @response `200` `SupplierDetailData` OK
     */
    supplierDetail: (
      { id, ...query }: SupplierDetailParams,
      params: RequestParams = {},
    ) =>
      this.http.request<SupplierDetailData, any>({
        path: `/api/Supplier/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supplier
     * @name SupplierList
     * @request GET:/api/Supplier
     * @secure
     * @response `200` `SupplierListData` OK
     */
    supplierList: (query: SupplierListParams, params: RequestParams = {}) =>
      this.http.request<SupplierListData, any>({
        path: `/api/Supplier`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Supplier
     * @name SupplierWithPurchaseInfoCreate
     * @request POST:/api/Supplier/with-purchase-info
     * @secure
     * @response `200` `SupplierWithPurchaseInfoCreateData` OK
     */
    supplierWithPurchaseInfoCreate: (
      query: SupplierWithPurchaseInfoCreateParams,
      data: SupplierWithPurchaseInfoCreatePayload,
      params: RequestParams = {},
    ) =>
      this.http.request<SupplierWithPurchaseInfoCreateData, any>({
        path: `/api/Supplier/with-purchase-info`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),
  };
}
